import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Chart.css'
import {Row, Col} from 'react-flexbox-grid'
import {Doughnut} from 'react-chartjs'
import format from '../../helpers/format'
import convert from '../../helpers/convert'

const chartOptions = {
  segmentStrokeWidth: 0,
  percentageInnerCutout: 70,
  animationEasing: 'easeOutQuad',
  // String - Template string for single tooltips
  tooltipTemplate: "<%if (label){%><%=label %> <%}%><%= value + ' %' %>",
  // String - Template string for multiple tooltips
  multiTooltipTemplate: "<%= value + ' %' %>",
}

@CSSModules(Styles)
export default class Chart extends Component {
  static propTypes = {
    renderBox: PropTypes.func.isRequired,
    currency: PropTypes.string.isRequired,
    invested: PropTypes.number.isRequired,
    tmPerc: PropTypes.number.isRequired,
    toPerc: PropTypes.number.isRequired,
    fundFamilyName: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props)
  }
  render() {
    const chartData = [
      {
        value: this.props.toPerc,
        label: 'Tobacco producers',
        color: '#C3001C'
      },
      {
        value: this.props.tmPerc,
        label: 'Entertainment companies',
        color: '#F2961C'
      },
      {
        value: !( this.props.toPerc === 0 && this.props.tmPerc === 0 )?(convert.float((100-this.props.tmPerc-this.props.toPerc).toFixed(2))):0,
        label: 'Other',
        color: '#CCCCCC'
      },
      {
        value: ( this.props.toPerc === 0 && this.props.tmPerc === 0 )?100:0,
        label: 'Other',
        color: '#CCCCCC' // green
      }]
    const toIcon = require( '../../../static/images/icon-cigarette.svg' )
    const tmIcon = require( '../../../static/images/icon-cinema.svg' )
    const name = this.props.fundFamilyName
    return (
      <div styleName='grade-chart-wrapper'>
      <Row styleName='grade-chart'>
        <Col xs={12} sm={6} md={4} styleName='box'>
          {
            this.props.tobaccoOverallRating ?
              (<div>{this.props.renderBox(name,
                                          this.props.tobaccoOverallRating,
                                          this.props.sri)}</div>) :
              (<div>{this.props.renderBox()}</div>)
          }
        </Col>
        <Col xs={12} sm={6} md={4} styleName='chart'>
          <Doughnut data={chartData} options={chartOptions}  width="300" height="300"/>
          <div styleName='chart-details'>
            <div styleName='chart-assets'>{ format.money(this.props.invested,true,this.props.currency) }</div>
            {
              (this.props.toPerc > 0 && this.props.tmPerc === 0)?
              (<div>INVESTED IN TOBACCO<br/>COMPANIES</div>):
              null
            }
            {
              (this.props.toPerc === 0 && this.props.tmPerc > 0)?
              (<div>INVESTED IN<br/>TOBACCO-PROMOTING<br/>ENTERTAINMENT COMPANIES</div>):
              null
            }
            {
              (this.props.toPerc > 0  && this.props.tmPerc > 0 )?
              (<div>INVESTED IN TOBACCO<br/>AND TOBACCO-PROMOTING<br/>ENTERTAINMENT COMPANIES</div>):
              null
            }
            {
              (this.props.toPerc === 0 && this.props.tmPerc=== 0)?
              (<div>INVESTED IN TOBACCO<br/>OR TOBACCO-PROMOTING<br/>ENTERTAINMENT COMPANIES</div>):
              null
            }
          </div>
        </Col>
        <Col xs={12} sm={12} md={4} styleName='labels'>
          <div styleName='tobacco'>
            <img styleName='to-icon' src={toIcon} alt='Tobacco companies that produce or manufacture tobacco products'/>
            <div styleName='to-label'>
              <div styleName='title'>
               Tobacco producers
              </div>
              <div styleName='intro'>
               that produce or manufacture tobacco products
              </div>
            </div>
          </div>
          <div styleName='movies'>
            <img styleName='tm-icon' src={tmIcon} alt='Entertainment companies that show smoking in movies marketed to kids'/>
            <div styleName='tm-label'>
              <div styleName='title'>
               Tobacco-promoting entertainment companies
              </div>
              <div styleName='intro'>
               that show smoking in movies marketed to kids
              </div>
            </div>
          </div>
        </Col>
      </Row>
      </div>
    )
  }
}

